export const createStripeCheckoutSession = async (payload) => {
  const baseURL = import.meta.env.VITE_API_BASE_URL;
  const url = baseURL.endsWith('/api')
    ? `${baseURL}/payment/stripe/create-checkout-session`
    : `${baseURL}/api/payment/stripe/create-checkout-session`;
  
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  
  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`Failed to create Stripe session: ${res.status} ${txt}`);
  }
  
  return await res.json(); // { success, sessionId, clientSecret }
};

export async function fetchStripeSummary(sessionId) {
  const baseURL = import.meta.env.VITE_API_BASE_URL;
  const url = baseURL.endsWith('/api')
    ? `${baseURL}/payment/stripe/summary?session_id=${sessionId}`
    : `${baseURL}/api/payment/stripe/summary?session_id=${sessionId}`;
  
  const r = await fetch(url);
  if (!r.ok) throw new Error('summary_fetch_failed');
  return r.json(); // { status, paymentId, amount, currency, method, sessionId, createdAt }
}

export async function waitForFinalStatus(sessionId, { intervalMs = 1000, timeoutMs = 60000 } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    const s = await fetchStripeSummary(sessionId);
    if (s.status === 'success' || s.status === 'failed') return s;
    await new Promise(r => setTimeout(r, intervalMs));
  }
  throw new Error('summary_timeout');
}

export function formatDateParts(isoOrMillis) {
  const d = new Date(isoOrMillis || Date.now());
  const formattedDate = d.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' });
  const formattedTime = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return { formattedDate, formattedTime, paymentDateTime: `${formattedDate} | ${formattedTime}` };
}

